import Pagination from "@/components/Pagination/Pagination"
import styles from "./BottomToolbar.module.css"

export default function BottomToolbar() {
  return (
    <div className={styles.wrapper}>
      <Pagination />
    </div>
  )
}
